import { createClient, SupabaseClient } from '@supabase/supabase-js';
import tokenService from '../utils/tokenService';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const buildAuthenticatedClientOptions = (token: string) => ({
    global: {
        headers: {
            'X-Client-Token': token,
        },
    },
});

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase URL and Anon Key must be provided in environment variables.');
}

// Client de base pour les requêtes publiques non authentifiées
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export class SupabaseService {
    /**
     * Crée un client Supabase spécifique à la requête avec le token d'auteur.
     * Le token est récupéré automatiquement par le tokenService.
     * @returns Une nouvelle instance du client Supabase.
     */
    public async getClient(): Promise<SupabaseClient> {
        const token = await tokenService.getToken();
        if (!token) {
            throw new Error('Authentication token not found. Please log in.');
        }

        return createClient(supabaseUrl!, supabaseAnonKey!, buildAuthenticatedClientOptions(token));
    }
}

export const supabaseService = new SupabaseService();
